import React from "react";
import { useTranslation } from "react-i18next";

import ModalWindow from "../../ModalWindow";
import { ICON } from "components/common/IconButton";
import DeleteDialog from "../DeleteDialog";
import TooltipButton from "components/common/InfoPopup/TooltipButton";

function DeleteModal({ data, onDeleteClick, buttonClasses }) {
    const { t } = useTranslation();

    return (
        <ModalWindow
            WindowComponent={DeleteDialog}
            ButtonComponent={(props) => (
                <TooltipButton hintText={t("delete_button")} icon={ICON.delete} {...props} />
            )}
            data={data}
            onDeleteClick={onDeleteClick}
            mode={buttonClasses}
        />
    );
}

export default DeleteModal;
